export default "__VITE_ASSET__CwoBlSNn__"